export const SENTRY_DSN =
  `https://2513b55afb4f453fad15f3e42f9e70ab@o372469.ingest.sentry.io/5283389` as const;
